import React from "react";
import styles from "../Login.module.scss";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
import FormTextfield from "../../../components/FormComponents/FormTextfield/FormTextfield";

const LoginForm = (props) => {
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log("Login Success", tokenResponse);
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res.data);
        })
        .catch((err) => console.log(err));
    },
    onError: (err) => {
      console.log("Login Failed", err);
    },
  });
  const parseFBResponse = (data) => {
    let res = {};
    if (data && data?.accessToken) {
      res.third_party_id = data.userID;
      res.name = data.name;
      res.email = data.email;
      res.access_token = data.accessToken;
      res.picture = data.picture?.data?.url;
    }
    return res;
  };
  const handleFacebookCallback = (response) => {
    if (response?.status === "unknown") {
      console.error("Sorry!", "Something went wrong with facebook Login.");
      return;
    }
    const parsedData = parseFBResponse(response);
    if (Object.keys(parsedData).length) {
      console.log("parsedData", parsedData);
    } else {
      console.log("Sorry!", "Something went wrong with facebook Login.");
    }
  };

  return (
    <div className={styles["form"]}>
      <FormTextfield label="Email" />
      <button
        className={styles["submit-button"]}
        onClick={() => props.setConfirmButtonClicked(true)}
      >
        Accedi
      </button>
      <p className={styles["heading"]}>Oppure accedi con...</p>
      <div className={styles["icon-buttons"]}>
        <button className={styles["social-buttons"]} onClick={() => login()}>
          <FcGoogle size={18} />
          <p className={styles["button-text"]}>Google</p>
        </button>
        <button className={styles["social-buttons"]}>
          <FaFacebook size={18} color="#316FF6" />
          <p className={styles["button-text"]}>Facebook</p>
        </button>
        <FacebookLogin
          buttonStyle={{ padding: "6px" }}
          appId="1727409364598014"
          autoLoad={false}
          fields="name,email,picture"
          callback={handleFacebookCallback}
        />
      </div>
    </div>
  );
};
export default LoginForm;
